import gameIds from 'a/hub/data/GameIds';

export const GAME_ID = gameIds.NEW_GAME;

// Fraction of first-try-correct items required to master a level (and unlock the next)
export const MASTERY_THRESHOLD = 0.75;

// Per-level item count for the progress screen display.
// The round itself reads the actual count from the curriculum (getLevelItemCount).
export const ITEMS_PER_LEVEL = 4;

export const SCREENS = {
  PROGRESS: 'PROGRESS',
  STANDARD: 'STANDARD',
  LOADING: 'LOADING',
  ONBOARDING: 'ONBOARDING',
  PRACTICE: 'PRACTICE',
};

export const REDUX_ACTIONS = {
  INITIALIZE_ROUND: 'INITIALIZE_ROUND',
  NEXT_STANDARD_ITEM: 'NEXT_STANDARD_ITEM',
  INCREMENT_QUESTIONS_CORRECT: 'INCREMENT_QUESTIONS_CORRECT',
  COMPLETE_ONBOARDING: 'COMPLETE_ONBOARDING',
};
